import React, { useRef, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import logo from 'assets/img/Logo-Humano.png';
import { Formik } from 'formik';
import { isBrowser } from "react-device-detect";
import { NavLink } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import Utils from '../../utils';
import { post } from 'services';
import { useHistory } from "react-router";
let yup = require('yup');
const Swal = require('sweetalert2');


const marginTopTen = {
  marginBottom: 10
}

const logoStyle = {
  ...marginTopTen,
  marginBottom: 10,
  width: 150,
  marginRight: 10
}


const ChangePassword = () => {
  const history = useHistory();
  const [reCAPTCHA, setReCAPTCHA] = useState('');
  const reRef = useRef();

  const schema = yup.object({
    userName: yup.string().email("Debe ser un correo").required('El usuario es requerido'),
    password: yup.string().required('La contraseña es requerida'),
    newPassword: yup.string().required('La nueva contraseña es requerida'),
    confirmNewPassword: yup.string().required('La confirmación de la nueva contraseña es requerida')
  });

  const onSumitted = async (data) => {
    if (data.newPassword === data.confirmNewPassword) {
      const dto = {
        username: data.userName,
        password: data.newPassword,
        recaptcha: reCAPTCHA
      };
      var result = await post(`Usuario/ChangePassword`, dto);
      if (result && result.data) {
        Swal.fire({
          icon: 'success',
          title: '¡Se ha actualizado la contraseña correctamente!',
          text: 'Favor ingresar sus credenciales para autenticarse'
        });
        history.push({
            pathname: "/",
            state: {}
        });
      } else {
        Swal.fire({
          icon: 'warning',
          title: '¡Atención!',
          text: '¡Intente nuevamente!'
        });
      }
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Atención!',
        text: '¡Las contraseñas son distintas!'
      });
    }
  }

  return (
    <div className="display-flex flex-center center-vertical flex-direction-column height-100 login-background">
      <div className={'padding-10'}>

        <div className={'display-flex flex-end'}>
          <img style={logoStyle} src={logo} alt="logo" />
        </div>

        <Card>
          <Card.Body className={'p-30'}>
            <Formik
              validationSchema={schema}
              onSubmit={onSumitted}
              initialValues={{
                userName: '',
                password: '',
                newPassword: '',
                confirmNewPassword: ''
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                  <Form.Row>

                    <Form.Group as={Col} md="6" controlId="validationFormik01">
                      <Form.Label> <strong> Correo </strong> </Form.Label>
                      <Form.Control
                        type="email"
                        name="userName"
                        value={values.userName}
                        onChange={handleChange}
                        isValid={touched.userName && !errors.userName}
                        isInvalid={!!errors.userName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.userName}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationFormik02">
                      <Form.Label> <strong> Contraseña </strong> </Form.Label>
                      <Form.Control
                        className="is-password"
                        type="text"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        isValid={touched.password && !errors.password}
                        isInvalid={!!errors.password}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationFormik02">
                      <Form.Label> <strong> Nueva contraseña </strong> </Form.Label>
                      <Form.Control
                        className="is-password"
                        type="text"
                        name="newPassword"
                        value={values.newPassword}
                        onChange={handleChange}
                        isValid={touched.newPassword && !errors.newPassword}
                        isInvalid={!!errors.newPassword}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.newPassword}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationFormik02">
                      <Form.Label> <strong> Confirmar nueva contraseña </strong> </Form.Label>
                      <Form.Control
                        className="is-password"
                        type="text"
                        name="confirmNewPassword"
                        value={values.confirmNewPassword}
                        onChange={handleChange}
                        isValid={touched.confirmNewPassword && !errors.confirmNewPassword}
                        isInvalid={!!errors.confirmNewPassword}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.confirmNewPassword}
                      </Form.Control.Feedback>
                    </Form.Group>

                  </Form.Row>



                  <ReCAPTCHA
                    style={{ marginBottom: 10 }}
                    sitekey={process.env.REACT_APP_NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                    onChange={setReCAPTCHA}
                    ref={reRef}
                    hl={'es'}
                  />

                  <div className={isBrowser ? 'display-flex space-between' : 'display-flex flex-direction-column center-vertical'}>
                    <div className={'display-flex flex-end-vertical'}>
                      <NavLink
                        to="/SolicitudEmpleo/IniciarSesion"
                        exact
                      >
                        Volver la login
                        </NavLink>
                    </div>
                    <Button disabled={reCAPTCHA === ""} type="submit"><strong>  Cambiar contraseña </strong> </Button>
                  </div>

                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>

      </div>
    </div>
  );
}

export default ChangePassword;
